jQuery(document).ready(function () {

    if ($(".glossary").length > 0 ) {
        $('[class^="alpha alpha-"]').click(function () {
            $(this).addClass("selected").siblings("a.alpha").removeClass("selected");
            $("div.list-object-" + $(this).text().toLowerCase()).addClass("selected").siblings("div.list-objects").removeClass("selected");
        });
    }
    
});